import type * as Types from '@shared/types/graphqlGenerated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type StoreSettingsQueryVariables = Types.Exact<{
  storeSlug: Types.Scalars['String']['input'];
}>;


export type StoreSettingsQuery = { viewer: { __typename: 'Viewer', storefrontConfig: { __typename: 'StorefrontConfig', storeId: string | null, name: string | null, slug: string | null, customAuthDisclaimer: string | null, customAuthPageMarketingCopy: string | null } | null } | null };


export const StoreSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StoreSettings_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storefrontConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"customAuthDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"customAuthPageMarketingCopy"}}]}}]}}]}}]} as unknown as DocumentNode;
export type StoreSettingsQueryQueryResult = Apollo.QueryResult<StoreSettingsQuery, StoreSettingsQueryVariables>;

export function useStoreSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<StoreSettingsQuery, StoreSettingsQueryVariables> & ({ variables: StoreSettingsQueryVariables; skip?: boolean; } | { skip: boolean; })
) {
  return Apollo.useQuery<StoreSettingsQuery, StoreSettingsQueryVariables>(
    StoreSettingsQueryDocument,
    baseOptions
  );
}

export function useStoreSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreSettingsQuery, StoreSettingsQueryVariables>) {
  return Apollo.useLazyQuery<StoreSettingsQuery, StoreSettingsQueryVariables>(
    StoreSettingsQueryDocument,
    baseOptions
  );
}

export function useStoreSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StoreSettingsQuery, StoreSettingsQueryVariables>) {
  return Apollo.useSuspenseQuery<StoreSettingsQuery, StoreSettingsQueryVariables>(
    StoreSettingsQueryDocument,
    baseOptions
  );
}
